"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _InfoBar = _interopRequireDefault(require("./InfoBar"));
var _ResourceTabs = _interopRequireDefault(require("./ResourceTabs"));
var _ResourceFromUrlModal = _interopRequireDefault(require("./ResourceFromUrlModal"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _style = _interopRequireDefault(require("./style.css"));
var _set2 = _interopRequireDefault(require("lodash/set"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var AppDefs = window.cccisd.appDefs;

/** Resource Center Package */
var CccisdLaravelResources = /*#__PURE__*/function (_React$Component) {
  _inherits(CccisdLaravelResources, _React$Component);
  var _super = _createSuper(CccisdLaravelResources);
  function CccisdLaravelResources() {
    _classCallCheck(this, CccisdLaravelResources);
    return _super.apply(this, arguments);
  }
  _createClass(CccisdLaravelResources, [{
    key: "render",
    value: function render() {
      var _this = this;
      var resourceId = this.props.match && Number(this.props.match.params.id);
      var resourceTab = this.props.match && this.props.match.params.tab;
      var urlSearchParams = new URLSearchParams(window.location.search);
      var params = Object.fromEntries(urlSearchParams.entries());
      if (params.tab) {
        resourceTab = params.tab;
      }
      if (!resourceId && Number(resourceTab) === parseInt(resourceTab, 10)) {
        resourceId = Number(resourceTab);
        resourceTab = null;
      }
      var config = this.props.config;
      if (!config && AppDefs.resourceCenters && AppDefs.resourceCenters.list) {
        config = AppDefs.resourceCenters.list.find(function (rc) {
          return rc.id === _this.props.handle;
        });
      }
      if (!config) {
        return /*#__PURE__*/_react["default"].createElement("div", null, "There is no resource center config for handle \"".concat(this.props.handle, "\""));
      }
      var _config = config,
        displayOptions = _config.displayOptions;
      if (this.props.hideShareButton) {
        (0, _set2["default"])(displayOptions, 'resources.showShareButton', false);
      }
      var getTitle = function getTitle() {
        if (config.showTitle) {
          return config.pageTitle ? /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            content: config.pageTitle
          }) : /*#__PURE__*/_react["default"].createElement("h1", null, config.title);
        }
        return null;
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: displayOptions.portal && displayOptions.portal.titleColor ? {
          color: displayOptions.portal.titleColor
        } : {},
        className: _style["default"].appdefsResources
      }, getTitle(), /*#__PURE__*/_react["default"].createElement(_InfoBar["default"], {
        config: config
      }), /*#__PURE__*/_react["default"].createElement(_ResourceTabs["default"], {
        id: config.id,
        initialTab: resourceTab,
        tags: config.tags,
        tabs: config.tabs,
        displayOptions: config.displayOptions,
        showTabs: config.showTabs,
        renderResourceTiles: this.props.renderResourceTiles
      }), /*#__PURE__*/_react["default"].createElement(_ResourceFromUrlModal["default"], {
        showResourceId: resourceId
      }));
    }
  }]);
  return CccisdLaravelResources;
}(_react["default"].Component);
exports["default"] = CccisdLaravelResources;
_defineProperty(CccisdLaravelResources, "propTypes", {
  handle: _propTypes["default"].string,
  renderResourceTiles: _propTypes["default"].func,
  match: _propTypes["default"].object,
  config: _propTypes["default"].object,
  hideShareButton: _propTypes["default"].bool
});